import { BaseValidator } from './base';
import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { VALID_LOCATION, VALID_LOCATIONS_PERSON } from 'apps/action_types';
import { FSA }                from 'flux-standard-action';
import { update }             from 'apps/actions/data';
import { deepmerge }          from 'utilities/merge';
import isEmail                from 'validator/lib/isEmail';
import isEmpty                from 'validator/lib/isEmpty';
import { newDataFromDot }     from 'utilities/hash';

class LocationValidator extends BaseValidator {
  properties = [];
}
class LocationsPersonValidator extends BaseValidator {
  properties = [];
}
export const validLocation = function*(){
  yield takeEvery(VALID_LOCATION, function*(action: FSA<any, any>){
    let validator;
    validator = new LocationValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    yield put(update(newData));
    validator.done();
  });
}
export const validLocationsPerson = function*(){
  yield takeEvery(VALID_LOCATIONS_PERSON, function*(action: FSA<any, any>){
    let validator;
    validator = new LocationsPersonValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    yield put(update(newData));
    validator.done();
  });
}
